// extracted by mini-css-extract-plugin
export default {"NavCol":"navtabs_NavCol__MLwxG","NavCard":"navtabs_NavCard__CwlR2","TabsList":"navtabs_TabsList__oND3p","activeTab":"navtabs_activeTab__sxciJ"};